import {
  Button,
  ClockSolidIcon,
  Div,
  H5,
  Icon,
  P,
  lightTheme,
} from '@vgrubs/components';
import { ScheduledPause } from 'components/src/types/api/location.types';
import { useState } from 'react';
import { scheduledPauseLabel } from './providerPause';

/**
 * The pauses set to start later on one target (a provider, or every provider
 * for Pause All), each with its Cancel. Unpause does not touch them: Cancel
 * is the only way to stop one from starting.
 */
export const ScheduledPauseCards = ({
  pauses,
  timeZone,
  onCancel,
}: {
  pauses: ScheduledPause[];
  timeZone?: string;
  onCancel: (pause: ScheduledPause) => Promise<void>;
}) => {
  const [cancelling, setCancelling] = useState<number | null>(null);

  if (!pauses.length) return null;

  const cancel = async (pause: ScheduledPause) => {
    setCancelling(pause.id);
    await onCancel(pause);
    setCancelling(null);
  };

  return (
    <Div $flex $column $gap="8px" $mb="16">
      {pauses.map((pause) => (
        <Div key={pause.id} $box $p="16px" $flex $column $gap="12px">
          <Div $textAlignLeft>
            <Div $flex $alignCenter $gap="8px">
              <Icon $size={18}>
                <ClockSolidIcon color={lightTheme.primary} />
              </Icon>
              <H5 $m="0">Pause scheduled</H5>
            </Div>
            <P $m="4px 0 0 0">
              {scheduledPauseLabel(pause, timeZone)}
              {pause.source === 'chat' && ' · from chat'}
            </P>
          </Div>
          <Button
            $w="100%"
            disabled={cancelling === pause.id}
            $loading={cancelling === pause.id}
            onClick={() => cancel(pause)}
          >
            Cancel scheduled pause
          </Button>
        </Div>
      ))}
    </Div>
  );
};
